import { render } from "./MINISTER_REVOKED.vue?vue&type=template&id=0ddba7d9"
import script from "./MINISTER_REVOKED.vue?vue&type=script&lang=js"
export * from "./MINISTER_REVOKED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__